export default {"src":"/_next/static/media/apex_leaf_logo.a324a9fe.svg","height":128,"width":129,"blurWidth":0,"blurHeight":0};